import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import LeaveApproval from '../components/LeaveApproval';
import NavBar from '../components/Menu/NavBar'
import { pageStyle } from '../components/UIComponent/CommonStyle'
import { setLocalStorageSettings } from '../components/Function/globalFunction';

const useStyles = makeStyles(() => ({
    ...pageStyle()
}));

export default function LeaveApprovalPage({ routing, routingId, source }) {
    const classes = useStyles();
    setLocalStorageSettings({
        'selectedIndex': 5,
        'isMyRequestOpen': 'false',
        'isApplicationOpen': 'false',
        'isLeaveApprovalOpen': 'true',
        'isHRAdminOpen': 'false'
    });

    return (
        <div className={classes.root}>
            <CssBaseline />
            <NavBar />
            <LeaveApproval routing={routing} routingId={routingId} source={source}/>
        </div>
    )
}